<template>
  <div class="coming-soon">
    <i class="el-icon-loading"></i>
    <h2>功能开发中，敬请期待...</h2>
    <el-button type="primary" @click="$router.push('/')">返回首页</el-button>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon'
}
</script>

<style scoped>
.coming-soon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px;
}

.el-icon-loading {
  font-size: 48px;
  color: #409EFF;
  margin-bottom: 20px;
}

h2 {
  margin-bottom: 30px;
  color: #606266;
}
</style> 